import React from 'react';
import { Switch } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
//-----------------------|| ROUTING RENDER ||-----------------------//

const Routes = () => {
    return (
        <Switch>
            <React.Fragment>
                {/* Routes for main layouts */}
                <MainRoutes />
            </React.Fragment>
        </Switch>
    );
};

export default Routes;
